export default "__VITE_ASSET__Ca_gwpSk__"